import styles from './styles.module.scss';
import { useLayoutEffect } from 'react';

/**
 * Хук для расширения максимальной ширины контейнеров
 * Применяет класс к kt_content_container и kt_header_container
 */
export const useExtendedContainer = () => {
  useLayoutEffect(() => {
    const containerIds = ['kt_content_container', 'kt_header_container'];
    const className = styles.extendedContainer;

    const elements = containerIds.map((id) => document.getElementById(id)).filter((element) => element !== null);

    elements.forEach((element) => {
      element?.classList?.add(className);
    });

    return () => {
      elements.forEach((element) => {
        element?.classList?.remove(className);
      });
    };
  }, []);
};
